import script from "./CRM60_006INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM60_006INS.vue?vue&type=script&setup=true&lang=js"

import "./CRM60_006INS.vue?vue&type=style&index=0&id=425a4c5b&scoped=true&lang=css"
import "./CRM60_006INS.vue?vue&type=style&index=1&id=425a4c5b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425a4c5b"]])

export default __exports__